import { TypeDict } from '@Types/index';
import { Option } from '@Components/types/options';
import { transformDictToOptions } from '@Utils/transformToOptions';

import { AttendanceRequestCodes } from './enum/AttendanceRequestTypeCodes.enum';
import { allowedReasonsTechnicalIssue } from '../constants';

export const prepareReasonOptions = (
  reasonsTypes: TypeDict[],
  reqType: number
): Option[] => {
  if (Number(reqType) === AttendanceRequestCodes.TECHNICAL_ISSUE) {
    const allowedReasons = reasonsTypes.filter(
      (reasonType) => allowedReasonsTechnicalIssue[reasonType.codeNum]
    );

    return transformDictToOptions(allowedReasons);
  }

  return transformDictToOptions(reasonsTypes);
};
